import React from 'react';
import {makeStyles} from "@material-ui/core/styles";
import { Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import Link from '@mui/material/Link';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import TwitterIcon from '@material-ui/icons/Twitter';
import MusicNoteIcon from '@material-ui/icons/MusicNote';
import keaLogo from '../assets/static/images/king-edward-zim-logo.png';
import Grid from '@material-ui/core/Grid';
import { BRAND_NAME, SOCIAL_LINKS } from '../shared/consts';
import { schoolAddress } from './configs/ContactData';

const useStyles = makeStyles((theme) => ({
  footer: {
    backgroundColor: '#24206f',
    padding: theme.spacing(6),
    color: theme.palette.background.paper,
  },
  root: {
      margin: theme.spacing(1),
      width: '25ch',
  },
  preFooter: {
    backgroundColor: '#f6f6f6;',
    padding: theme.spacing(4),
    color: '#900309',
    marginTop: '80px',
  },
}));

function Copyright() {
  return (
    <Typography variant="body2" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://beeframeworks.co.uk/">
        Bee Frameworks
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

// Only accounts with a URL in SOCIAL_LINKS are shown, so a visitor is never
// sent to a page that is not ours.
const socialAccounts = [
  { key: 'facebook', label: 'Facebook', Icon: FacebookIcon },
  { key: 'instagram', label: 'Instagram', Icon: InstagramIcon },
  { key: 'tiktok', label: 'TikTok', Icon: MusicNoteIcon },
  { key: 'twitter', label: 'Twitter', Icon: TwitterIcon }
].filter((account) => Boolean(SOCIAL_LINKS[account.key]));

function Footer() {
  const classes = useStyles();

  const openSocial = (key) => {
    window.open(SOCIAL_LINKS[key], '_blank', 'noopener,noreferrer');
  };

  return (
    <div>
      <footer className={classes.preFooter}>
        <Typography variant="h6" align="center" gutterBottom>
          Connect with us
        </Typography>
        <div style={{textAlign: 'center', margin: '20px'}}>
          {socialAccounts.map(({ key, label, Icon }) => (
            <Icon key={key}
                  titleAccess={`${BRAND_NAME} on ${label}`}
                  onClick={() => openSocial(key)}
                  style={{ margin: '15px', width: '50px', height: '50px', cursor: 'pointer'}}/>
          ))}
        </div>

      </footer>
      {/* Footer */}
      <footer className={classes.footer}>
        <Grid container spacing={2} justify="center">
          <Grid item xs={12} sm={4}>
            <div style={{color: 'white', textAlign: 'center'}}>
              <div
                style={{backgroundPosition: 'center',
                  backgroundRepeat: 'no-repeat',
                  height: '100px',
                  backgroundImage: `url(${keaLogo})`,
                  backgroundSize: 'contain',
                  marginBottom: '15px'
                }}
              >
              </div>
              <Typography variant='h6' style={{color: 'white', fontWeight: 700}}>
                { BRAND_NAME }
              </Typography>
              <Typography variant='h8' style={{color: 'white', fontSize: '0.8rem'}}>
                {schoolAddress.map((line) => (
                  <React.Fragment key={line}>{line}<br/></React.Fragment>
                ))}
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} sm={4}>
            <div style={{color: 'white', textAlign: 'center'}}>

              <Typography variant='h6' style={{color: '#fff', fontWeight: 800, paddingBottom: '20px'}}>
                Our School
              </Typography>

              <div style={{fontSize: '0.8rem'}}>
                <RouterLink className="white-link" to="/academics">
                  Academics
                </RouterLink> <br/><br/>
                <RouterLink className="white-link" to="/sports">
                  Sports
                </RouterLink> <br/><br/>
                <RouterLink className="white-link" to="/clubs-and-societies">
                  Clubs and Societies
                </RouterLink> <br/><br/>
                <RouterLink className="white-link" to="/pricing">
                  Fees
                </RouterLink> <br/><br/>
                <RouterLink className="white-link" to="/policies">
                  Policies
                </RouterLink>
              </div>
            </div>
          </Grid>
          <Grid item xs={12} sm={4}>
            <div style={{color: 'white', textAlign: 'center'}}>
              <Typography variant='h6' style={{color: '#fff', fontWeight: 800, paddingBottom: '20px'}}>
                Social Media
              </Typography>
              <div style={{fontSize: '0.8rem'}}>
                {socialAccounts.map(({ key, label }) => (
                  <React.Fragment key={key}>
                    <Link
                      color="inherit"
                      href={SOCIAL_LINKS[key]}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {label}
                    </Link> <br /><br />
                  </React.Fragment>
                ))}
              </div>
            </div>
          </Grid>
        </Grid>
        <hr style={{marginBottom: '20px', border: '1px solid #403c87', marginTop: '25px'}}/>
        <Copyright />
      </footer>
      {/* End footer */}
    </div>
  )
}

export default Footer;